export enum HeaderTable{
  titleForVehicleModelTable = 'Model',  
}

export enum HeaderColumns {
  vehicleModelName = 'Model',  
}

export enum ModalForAddOrUpdateVehicleModel {
  titleForAddVehicleModel = 'Dodavanje novog modela',
  titleForUpdateVehicleModel = 'Izmena naziva modela',
  vehicleModelNameEmpty = 'Potrebno je uneti naziv modela.',
  vehicleModelNamePlaceholder = 'Model',
  saveSuccessMessage = 'Nova model je uspešno sačuvan.',
  updateSuccessMessage = 'Naziv modela je uspešno izmenjen.',
  deleteSuccessMessage = 'Izabran model je uspešno obrisan.',
}
